import { Component, inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';

import { User } from '@digital-platform/rs-auth/domain';
import { IdentityService } from '@digital-platform/rs-auth/services';
import { HeaderResponse, NavLinks } from '@digital-platform/rs-cms/domain';
import { NavigationHelperService } from '@digital-platform/rs-cms/feature-ptypes';
import { CmsContentService } from '@digital-platform/rs-cms/services';

@UntilDestroy()
@Component({
  selector: 'digital-platform-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public identityService: IdentityService = inject(IdentityService);
  public userState?: User['state'];

  private navigationHelperService = inject(NavigationHelperService);

  private cmsContentService = inject(CmsContentService);
  pageContent!: HeaderResponse[0];
  pageContentOriginal!: HeaderResponse[0];
  icons: string[] = [
    'rs-icon-money',
    'rs-icon-calendar',
    'rs-icon-question',
    'rs-icon-exclamation',
  ];

  public ngOnInit() {
    this.cmsContentService
      .getHeaderContent()
      .pipe(map((response: HeaderResponse) => response[0]))
      .subscribe((headerResponse: HeaderResponse[0]) => {
        this.pageContentOriginal = headerResponse;
        // Generate initial link urls when page content is loaded
        this.generateLinkUrls();
      });

    this.identityService.user$
      .pipe(untilDestroyed(this))
      .subscribe((user: User) => {
        // Only generate link urls when user state changes
        if (this.userState !== user.state) {
          this.userState = user.state;

          // Generate link urls when user state changes
          this.generateLinkUrls();
        }
      });
  }

  public navigate(event: Event, url: string | null): void {
    this.navigationHelperService.navigate(event, url ?? '', true);
  }

  private generateLinkUrls(): void {
    // Reset the page content `link_urls` to the original state. Use deep clone to avoid modifying the original object
    this.pageContent = _.cloneDeep(this.pageContentOriginal);

    for (const navLinks of this.pageContent.utility_links) {
      // Modify the page content `link_urls` to the generated link url
      navLinks.link_url = this.generateLinkUrl(navLinks);
    }
  }

  private generateLinkUrl(item: NavLinks): NavLinks['link_url'] {
    let linkUrl;
    if (this.identityService.isLoggedIn) {
      // Conditional link url based on user state
      switch (this.userState) {
        case 'AS1': {
          linkUrl = item?.link_url_as1;
          break;
        }
        case 'AS2': {
          linkUrl = item?.link_url_as2;
          break;
        }
        case 'AS3': {
          linkUrl = item?.link_url_as3;
          break;
        }
        case 'AS4': {
          linkUrl = item?.link_url_as4;
          break;
        }

        default: {
          linkUrl = item.link_url;
          break;
        }
      }
    } else {
      // Logged out
      linkUrl = item.link_url;
    }

    return linkUrl;
  }
}
